var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box-small dashboard-box card-box-small-banner border-radius-8 border-0"},[_c('a',{staticClass:"d-block h-100 overflow-hidden border-radius-8",attrs:{"href":_vm.linkUrl,"target":"_blank","rel":"noopener noreferrer"}},[_c('div',{staticClass:"card-bg d-flex justify-content-between align-items-center",style:({
            backgroundImage: `url(${_vm.imageUrl})`,
            backgroundColor: _vm.backgroundColor,
            backgroundSize:  _vm.backgroundSize,
            backgroundPosition: _vm.backgroundPosition
        })},[(_vm.$slots.default)?_c('div',{class:['card-content', 'p-3', _vm.defaultSlotClass],style:({
                maxWidth: _vm.maxWidth
            })},[_vm._t("default")],2):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }